import createLucideIcon from '../createLucideIcon';

const CircleEqual = createLucideIcon('CircleEqual', [
  ['path', { d: 'M7 10h10', key: '1101jm' }],
  ['path', { d: 'M7 14h10', key: '1mhdw3' }],
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
]);

export default CircleEqual;
